import { DirectSaleStatisticsResponse } from '@/core/domain/sales/DirectSale/DirectSale.types';
import { useChartTheme } from '@/hooks';
import { metricPrefixFormatter } from '@/utils/number';
import { ResponsiveBar } from '@nivo/bar';
import { Card, Typography } from 'antd';

interface Props {
  directSaleStatistics?: DirectSaleStatisticsResponse;
}

const DirectSalePrincingChart: React.FC<Props> = ({
  directSaleStatistics: statistics,
}) => {
  const theme = useChartTheme();

  return (
    <Card style={{ borderRadius: 4 }}>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        Venda direta em R$
      </Typography.Title>
      <div style={{ height: 300 }}>
        <ResponsiveBar
          margin={{ top: 24, right: 24, bottom: 48, left: 48 }}
          colors={(datum) => datum.data.color}
          valueFormat={(value) =>
            value.toLocaleString('pt-br', {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: 'currency',
              currency: 'BRL',
            })
          }
          tooltipLabel={(datum) => datum.data.status}
          data={[
            {
              id: 'Autorizados',
              status: 'Autorizados',
              color: 'hsl(154, 70%, 50%)',
              amount: statistics?.authorizedSaleRevenue || 0,
            },
            {
              id: 'Abertos',
              status: 'Abertos',
              color: 'hsl(200, 100%, 50%)',
              amount: statistics?.openSaleRevenue || 0,
            },
            {
              id: 'Cancelados',
              status: 'Cancelados',
              color: 'hsl(0, 90%, 60%)',
              amount: statistics?.canceledSaleRevenue || 0,
            },
          ]}
          keys={['amount']}
          indexBy="status"
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 5,
            format: (value) => metricPrefixFormatter(value),
            legendOffset: -50,
            legendPosition: 'middle',
          }}
          theme={theme}
        />
      </div>
    </Card>
  );
};

export default DirectSalePrincingChart;
